import githubLogo from "../images/social-media-logos/github-logo.png";
import kaggleLogo from "../images/social-media-logos/kaggle-logo.png";
import linkedInLogo from "../images/social-media-logos/linkedin-logo.png";
import emailLogo from "../images/social-media-logos/email-logo.png";

const socialLogos = [
  {
    src: githubLogo,
    alt: "GitHub Logo",
    href: "https://github.com/davitegoian",
    name: "GitHub",
  },
  {
    src: kaggleLogo,
    alt: "Kaggle Logo",
    href: "https://www.kaggle.com/davitegoian",
    name: "Kaggle",
  },
  {
    src: linkedInLogo,
    alt: "LinkedIn Logo",
    href: "https://www.linkedin.com/in/davitegoian/",
    name: "LinkedIn",
  },
  {
    src: emailLogo,
    alt: "Email Logo",
    href: "mailto:dato.egoyan@gmail.com",
    name: "Email",
  },
];

export default socialLogos;
